<template>
  <div>
    <vue-form class="form-horizontal form-validation"  :state="formstate" @submit.prevent="onSubmit">
    <b-row class="toolbar-ptc">
      <b-col>
        <router-link :to="{ name: 'user_management', params: { search: search, sName: this.$route.params.sName } }" class="btn btn-ptc1" tag="button">返回</router-link>
      </b-col>
      <b-col class="text-center title">系統管理 / 使用者管理 / {{title}}</b-col>
      <b-col>
        <div class="text-right">
          <button class="btn btn-save" type="submit" v-if="FunctionPermission > 1 && isEdit">儲存</button>
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-card :title="title" class="mb-2">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-12">
                  <validate tag="div">
                  <b-form-group id="exampleInputGroup1"
                                label="使用者帳號"
                                label-for="exampleInput1">
                    <b-form-input id="exampleInput1"
                                  name="exampleInput1"
                                  type="text"
                                  required
                                  :disabled="FunctionPermission < 2 || !isEdit"
                                  placeholder="請輸入員工編號"
                                  v-model="account">
                    </b-form-input>
                    <field-messages name="exampleInput1" show="$invalid && $submitted" class="text-danger">
                        <div slot="required">使用者帳號為必填</div>
                    </field-messages>
                  </b-form-group>
                  </validate>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-12">
                  <validate tag="div">
                  <b-form-group id="exampleInputGroup2"
                                label="使用者姓名"
                                label-for="exampleInput2">
                    <b-form-input id="exampleInput2"
                                  name="exampleInput2"
                                  type="text"
                                  required
                                  placeholder="請輸入姓名"
                                  :disabled="FunctionPermission < 2 || !isEdit"
                                  v-model="name">
                    </b-form-input>
                    <field-messages name="exampleInput2" show="$invalid && $submitted" class="text-danger">
                        <div slot="required">使用者姓名為必填</div>
                    </field-messages>
                  </b-form-group>
                  </validate>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-12">
                  <b-form-group id="exampleInputGroup4"
                                label="起始日"
                                label-for="exampleInput4">
                    <b-form-input id="exampleInput4"
                                  type="text"
                                  required
                                  v-model="sdate"
                                  disabled>
                    </b-form-input>
                  </b-form-group>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-12" v-show="show_edate">
                  <b-form-group id="exampleInputGroup5"
                                label="停用日"
                                label-for="exampleInput5">
                    <b-form-input id="exampleInput5"
                                  type="text"
                                  required
                                  v-model="edate"
                                  disabled>
                    </b-form-input>
                  </b-form-group>
                </div>
              </div>
            </div>
          <table class="table b-table table-sm table-striped" >
            <thead class="thead-default">
              <tr>
                <th style="padding: 0.75rem; width:100px">權限角色</th>
                <th><div class="text-danger" style="padding: 0.3rem" v-if="v_role === false">請至少勾選一個角色</div>
                    <div v-else></div></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in roles" :key="item.id">
                <td style="padding: 0.75rem" colspan="2"><b-form-checkbox :value="item.id" :disabled="FunctionPermission < 2 || !isEdit" v-model="checkedRoles" checked="true">{{item.name}}</b-form-checkbox></td>
              </tr>
            </tbody>
          </table>
      </b-card>
    </div>
    </vue-form>
  </div>
</template>

<script>
// for API_URL
import axios from 'axios'
import {API_URL} from '../../store/root.js'
// for 訊息視窗
import miniToastr from 'mini-toastr'
// 功能權限function
import {getFunctionPermission} from '../../js/LoginUserFunction.js'

miniToastr.init()

export default {
  name: 'HelloWorld',
  data () {
    return {
      isEdit: false,
      account: '',
      name: '',
      sdate: '',
      edate: '',
      roles: [],
      checkedRoles: [],
      unCheckedRoles: [],
      show_edate: true,
      v_role: true, // 角色checkbox驗證
      formstate: {}, // 驗證用
      FunctionPermission: 0, // 功能權限
      title: '',
      search: {} // 記錄查詢條件
    }
  },
  created () {
    var params = this.$route.params
    if (params.userId === undefined) {
      this.$router.push({ name: 'user_management' })
      return
    }
    this.search = params.search
    this.FunctionPermission = getFunctionPermission('F02') // 功能權限 帶入功能代碼
    if (this.FunctionPermission > 1) {
      if (params.isEdit === true) {
        this.title = '修改使用者'
      } else {
        this.title = '使用者明細'
      }
    } else if (this.FunctionPermission === 1) {
      this.$router.push({ name: 'user_management' })
      return
    } else {
      this.$router.push({ name: 'name' })
      return
      // this.title = '使用者明細'
    }
    this.load()
  },
  methods: {
    onSubmit: function () {
      // 自己寫驗證checkbox必填
      var arrCB = this.checkedRoles
      var isChecked = false
      this.roles.forEach(function (arrRole, Index) {
        arrCB.forEach(function (CheckItem) {
          if (arrRole.id === CheckItem) {
            isChecked = true
          }
        })
      })
      this.v_role = isChecked

      if (this.formstate.$invalid || this.v_role === false) {
      } else {
        this.edit()
      }
    },
    load () {
      this.$parent.Loading = true
      this.isEdit = this.$route.params.isEdit
      return axios.post(API_URL + '/web/user/page/edit_data', {
        userId: this.$route.params.userId
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.account = response.data.data.account
            this.name = response.data.data.name
            this.sdate = response.data.data.enabledAt
            this.edate = response.data.data.disabledAt
            this.roles = response.data.data.roles

            if (response.data.data.disabledAt === '9999/12/31') {
              this.edate = ''
              this.show_edate = false
            }

            var arrCB = this.checkedRoles
            response.data.data.roles.forEach(function (arrRole, Index) {
              if (arrRole.checked === true) {
                arrCB.push(arrRole.id)
              }
            })
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(true, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    edit () {
      var arrAll = []
      var arrCB = this.checkedRoles
      var isChecked
      this.roles.forEach(function (arrRole, Index) {
        isChecked = false
        arrCB.forEach(function (CheckItem) {
          if (arrRole.id === CheckItem) {
            isChecked = true
          }
        })
        arrAll.push({
          id: arrRole.id,
          checked: isChecked
        })
      })
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/user/page/edit', {
        UserId: this.$route.params.userId,
        Account: this.account,
        Name: this.name,
        Roles: arrAll
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('修改成功')
            this.$router.push({name: 'user_management', params: { search: this.search, sName: this.$route.params.sName }}) // 分頁處理 : 回 上一頁列表該去的分頁
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.ui-breadcrumb {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/userManagementEdit.vue